
export default {
    data() {
        return {
            showIf: 'pro-beta',
            host: window.location.host,
        }
    },
    computed: {
        showTopBar: {
            get() {
                return this.host.includes(this.showIf);
            }
        }
    }
}